// Debug flag to control console logging
function canonicalProductUrl(url) {
  if (!url) return '';
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.origin + parsed.pathname.replace(/\/$/, '');
  } catch (e) {
    return String(url).split('?')[0].replace(/\/$/, '');
  }
}
function getHandleFromProductUrl(url) {
  if (!url) return null;
  const parts = String(url).split('/products/');
  if (parts.length < 2) return null;
  return parts[1].split('?')[0].replace(/\/$/, '');
}
function getWishlistHandles(listContents) {
  if (!Array.isArray(listContents)) return [];
  return listContents.map(item => getHandleFromProductUrl(item.du)).filter(Boolean);
}
function isProductPage() {
  return window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'product';
}
let globalUpdateWishlistIcons = null;
function initPlpWishlist(swat, wishlistId, listContents) {
  function addToWishlist(productData, lid) {
    if (!productData.variantId || !productData.productId || !productData.url) {
      return;
    }
    const product = {
      epi: productData.variantId,
      empi: productData.productId,
      du: canonicalProductUrl(productData.url)
    };
    swat.addToList(lid, product, function () {
      updateWishlistIcon(productData.handle, true);
      window.dispatchEvent(new CustomEvent('wishlist:product-added', {
        detail: {
          productId: productData.productId,
          variantId: productData.variantId,
          url: product.du
        }
      }));
      if (typeof window.refreshSwymWishlist === 'function') {
        window.refreshSwymWishlist().catch(() => {});
      }
    }, function (error) {
      console.error('Swym addToList error:', error);
    });
  }
  function removeFromWishlist(productData, lid) {
    if (!productData.variantId || !productData.productId || !productData.url) {
      return;
    }
    const product = {
      epi: productData.variantId,
      empi: productData.productId,
      du: canonicalProductUrl(productData.url)
    };
    swat.deleteFromList(lid, product, function () {
      updateWishlistIcon(productData.handle, false);
      window.dispatchEvent(new CustomEvent('wishlist:product-removed', {
        detail: {
          productId: productData.productId,
          variantId: productData.variantId,
          url: product.du
        }
      }));
      if (typeof window.refreshSwymWishlist === 'function') {
        window.refreshSwymWishlist().catch(() => {});
      }
    }, function (error) {
      console.error('Swym deleteFromList error:', error);
    });
  }
  function updateWishlistIcon(handle, isInWishlist) {
    document.querySelectorAll('.product-item').forEach(productItem => {
      const productLink = productItem.querySelector('.product-item__aspect-ratio');
      if (!productLink) return;
      const productHandle = getHandleFromProductUrl(productLink.getAttribute('href'));
      if (productHandle !== handle) return;
      const wishlistIcon = productItem.querySelector('.product-item__wishlist-icon');
      if (!wishlistIcon) return;
      if (isInWishlist) {
        wishlistIcon.innerHTML = `
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
          </svg>
        `;
        wishlistIcon.setAttribute('data-in-wishlist', 'true');
      } else {
        wishlistIcon.innerHTML = `
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
          </svg>
        `;
        wishlistIcon.setAttribute('data-in-wishlist', 'false');
      }
    });
  }
  function updateWishlistIconForSwatchChange(productItem, newProductUrl, cachedListContents) {
    const newHandle = getHandleFromProductUrl(newProductUrl);
    if (!newHandle) return;
    const wishlistHandles = getWishlistHandles(cachedListContents);
    const isInWishlist = wishlistHandles.includes(newHandle);
    const wishlistIcon = productItem.querySelector('.product-item__wishlist-icon');
    if (!wishlistIcon) return;
    if (isInWishlist) {
      wishlistIcon.innerHTML = `
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
        </svg>
      `;
      wishlistIcon.setAttribute('data-in-wishlist', 'true');
    } else {
      wishlistIcon.innerHTML = `
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
        </svg>
      `;
      wishlistIcon.setAttribute('data-in-wishlist', 'false');
    }
  }
  function addSwatchChangeListeners(cachedListContents) {
    document.querySelectorAll('.swatch-item').forEach(swatch => {
      swatch.removeEventListener('click', swatch.swatchChangeHandler);
      swatch.swatchChangeHandler = function () {
        const productItem = swatch.closest('.product-item');
        if (!productItem) return;
        const swatchData = swatch.dataset;
        const newProductId = swatchData.groupedProductId;
        const newVariantId = swatchData.groupedProductVariantId || swatchData.groupedProductId;
        if (!newProductId) return;
        productItem.setAttribute('data-product-id', newProductId);
        if (newVariantId) {
          productItem.setAttribute('data-variant-id', newVariantId);
        }
        const listContents = window.__swymData && window.__swymData.listContents || cachedListContents;
        updateWishlistIconForSwatchChange(productItem, swatchData.groupedProductAnchor, listContents);
      };
      swatch.addEventListener('click', swatch.swatchChangeHandler);
    });
  }
  function addWishlistClickListeners(lid) {
    document.querySelectorAll('.product-item__wishlist-icon').forEach(icon => {
      icon.removeEventListener('click', icon.wishlistClickHandler);
      icon.wishlistClickHandler = function (e) {
        e.preventDefault();
        e.stopPropagation();
        const productItem = icon.closest('.product-item');
        if (!productItem) return;
        const productId = productItem.getAttribute('data-product-id');
        const variantId = productItem.getAttribute('data-variant-id');
        const productLink = productItem.querySelector('.product-item__aspect-ratio');
        if (!productLink || !productId || productId === 'null' || productId === 'undefined') {
          return;
        }
        const productUrl = productLink.getAttribute('href');
        const handle = getHandleFromProductUrl(productUrl);
        if (!handle) return;
        const parsedProductId = parseInt(productId, 10);
        const parsedVariantId = parseInt(variantId, 10);
        if (isNaN(parsedProductId) || parsedProductId <= 0 || isNaN(parsedVariantId) || parsedVariantId <= 0) {
          return;
        }
        const productData = {
          productId: parsedProductId,
          variantId: parsedVariantId,
          handle: handle,
          url: canonicalProductUrl(window.location.origin + productUrl)
        };
        if (icon.getAttribute('data-in-wishlist') === 'true') {
          removeFromWishlist(productData, lid);
        } else {
          addToWishlist(productData, lid);
        }
      };
      icon.addEventListener('click', icon.wishlistClickHandler);
    });
  }
  function updateWishlistIcons(wishlistProductIds, lid, cachedListContents) {
    document.querySelectorAll('.product-item').forEach(productItem => {
      const wishlistIcon = productItem.querySelector('.product-item__wishlist-icon');
      const productLink = productItem.querySelector('.product-item__aspect-ratio');
      if (!wishlistIcon || !productLink) return;
      const handle = getHandleFromProductUrl(productLink.getAttribute('href'));
      if (!handle) return;
      if (wishlistProductIds.includes(handle)) {
        wishlistIcon.innerHTML = `
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
          </svg>
        `;
        wishlistIcon.setAttribute('data-in-wishlist', 'true');
      } else {
        wishlistIcon.innerHTML = `
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
          </svg>
        `;
        wishlistIcon.setAttribute('data-in-wishlist', 'false');
      }
    });
    addWishlistClickListeners(lid);
    addSwatchChangeListeners(cachedListContents);
  }
  function applyListContents(contents) {
    const wishlistProductIds = getWishlistHandles(contents);
    updateWishlistIcons(wishlistProductIds, wishlistId, contents);
  }
  globalUpdateWishlistIcons = applyListContents;
  applyListContents(listContents);
  window.addEventListener('wishlist:product-added', e => {
    const {
      productId
    } = e.detail || {};
    if (!productId) return;
    document.querySelectorAll(`.product-item[data-product-id="${productId}"] .product-item__wishlist-icon`).forEach(icon => {
      icon.innerHTML = `
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
        </svg>
      `;
      icon.setAttribute('data-in-wishlist', 'true');
    });
  });
  window.addEventListener('wishlist:product-removed', e => {
    const {
      productId
    } = e.detail || {};
    if (!productId) return;
    document.querySelectorAll(`.product-item[data-product-id="${productId}"] .product-item__wishlist-icon`).forEach(icon => {
      icon.innerHTML = `
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
        </svg>
      `;
      icon.setAttribute('data-in-wishlist', 'false');
    });
  });
  window.addEventListener('swym:bootstrapped', event => {
    if (event.detail && event.detail.listContents) {
      applyListContents(event.detail.listContents);
    }
  });
}
function startPlpWishlist(data) {
  if (!data || !data.swat || !data.wishlistId) return;
  initPlpWishlist(data.swat, data.wishlistId, data.listContents || []);
}
if (!isProductPage()) {
  if (window.__swymData) {
    startPlpWishlist(window.__swymData);
  } else {
    window.addEventListener('swym:bootstrapped', event => {
      startPlpWishlist(event.detail);
    }, {
      once: true
    });
  }
}
document.addEventListener('pagination:content-updated', function () {
  if (window.__swymData && globalUpdateWishlistIcons) {
    globalUpdateWishlistIcons(window.__swymData.listContents || []);
    return;
  }
  if (typeof window.refreshSwymWishlist === 'function') {
    window.refreshSwymWishlist().then(data => {
      if (globalUpdateWishlistIcons) {
        globalUpdateWishlistIcons(data.listContents || []);
      }
    }).catch(() => {});
  }
});
